import * as React from 'react';

import { PictureProfile } from '../../../../../ResizedImage/PictureProfile.csharp';
import { getTranslation, keys } from '../../../../../Resources/Translations';
import { CartItem } from '../../../../Purchase/Cart/Item/Components/CartItem/CartItem';
import { CartItemViewModel } from '../../../../Purchase/Cart/Item/ViewModels/CartItemViewModel.csharp';

interface OrderDetailsNotShippablePackageProps {
    items: CartItemViewModel[];
    pictureProfile: PictureProfile;
}

export const OrderDetailsNotShippablePackage = (props: OrderDetailsNotShippablePackageProps) => {
    const { items, pictureProfile } = props;

    return (
        <div className="OrderDetailsPackage CartItems--NotEditable">
            <div className="OrderDetailsPackage__Header">
                <div className="OrderDetailsPackage__Shipping">
                    <span className="OrderDetailsPackage__Heading">{`${getTranslation(keys['orderSummary.specialItems'])}`}</span>
                </div>
            </div>
            <div className="OrderDetailsPackage__Items">
                {items.map((item) => (
                    <CartItem
                        key={item.code}
                        item={item}
                        pictureProfile={pictureProfile}
                        hideItemAvailability
                        showQuantity
                        showFavouriteButton
                        priceLayout="checkout"
                    />
                ))}
            </div>
        </div>
    );
};
